<template>
  <section>
    <div class="flex justify-between md:flex-row flex-col">
      <h6 class="text-xl font-semibold leading-normal mt-0 mb-4 text-gray-dark">
        Earnings Per User
      </h6>
      <DateFilter
        :handleDateChange="handleDateChange"
        :handleDateFilterCategoryChange="handleDateFilterCategoryChange"
        :dateFilterCategory="dateFilterCategory"
        :monthOfMonthAndYear="monthOfMonthAndYear"
        monthOfMonthAndYearId="monthOfMonthAndYear"
        yearOfMonthAndYearId="yearOfMonthAndYear"
        yearId="year"
        startDateId="startDate"
        endDateId="endDate"
        :yearOfMonthAndYear="yearOfMonthAndYear"
        :year="year"
        :startDate="startDate"
        :endDate="endDate"
      />
    </div>
    <TableAlt :thead="tableHead">
      <tbody
        class="bg-white divide-y divide-gray-200"
        v-if="
          trainerTransactionsByusersData &&
          trainerTransactionsByusersData.length
        "
      >
        <tr v-for="d in trainerTransactionsByusersData" :key="d.id">
          <td
            class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark capitalize"
          >
            <div
              class="flex md:flex-row flex-col items-center space-x-2 capitalize"
            >
              <Avatar
                :classStr="'h-8 w-8'"
                :src="baseUrlSrc(d && d.thumbnail_url)"
              />
              <span>{{ d.name }}</span>
            </div>
          </td>
          <td
            class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark capitalize"
          >
            {{ d.top_session }}
          </td>
          <td class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark">
            {{ d.classes_subscribed }}
          </td>
          <td class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark">
            ${{ d.paid_amount }}
          </td>
          <td class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark">
            {{ dateFormat(d.last_subscribed) }}
          </td>
          <td class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark">-</td>
        </tr>
      </tbody>
    </TableAlt>
    <div v-if="loadingStatus">
      <p class="text-center">Loading...</p>
    </div>
    <div v-else>
      <div v-if="!trainerTransactionsByusersData">
        <EmptyTable :description="'Try adjusting the filters to see more.'" />
      </div>
    </div>
  </section>
</template>

<script>
import DateFilter from "@/components/DateFilter.vue";

import { Avatar, TableAlt, EmptyTable } from "@/components/t-components";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "EarningUsers",
  components: {
    DateFilter,
    Avatar,
    TableAlt,
    EmptyTable,
  },
  data() {
    return {
      tableHead: [
        "User",
        "Top Class",
        "Class Attended",
        "Amount",
        "Last Class",
        "Transfer",
      ],
      dateFilterCategory: "month",
      yearOfMonthAndYear: "",
      monthOfMonthAndYear: "",
      year: "selectyear",
      startDate: "",
      endDate: "",
      trainerTransactionsByusersData: [],
      currentPage: 1,
      totalPages: "",
    };
  },
  computed: {
    ...mapGetters(["trainerTransactionsByusers"]),

    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
  methods: {
    ...mapActions(["postTrainerTransactionsByusers"]),

    handleDateFilterCategoryChange(event) {
      this.dateFilterCategory = event.target.value;
    },

    async handleDateChange(event) {
      let startDate = null;
      let endDate = null;
      if (event.target.id === "startDate") {
        startDate = event.target.value;
        endDate = this.endDate;
      } else if (event.target.id === "endDate") {
        endDate = event.target.value;
        startDate = this.startDate;
      } else if (event.target.id === "monthOfMonthAndYear") {
        const month = Number(event.target.value);
        const year = this.yearOfMonthAndYear;
        this.monthOfMonthAndYear = month;

        startDate = moment(new Date(year, month, 1)).format("YYYY-MM-DD");
        endDate = moment(new Date(year, month + 1, 0)).format("YYYY-MM-DD");
      } else if (event.target.id === "yearOfMonthAndYear") {
        const year = Number(event.target.value);
        const month = this.monthOfMonthAndYear;
        this.yearOfMonthAndYear = year;
        startDate = moment(new Date(year, month, 1)).format("YYYY-MM-DD");
        endDate = moment(new Date(year, month + 1, 0)).format("YYYY-MM-DD");
      } else if (event.target.id === "year") {
        const year = Number(event.target.value);
        this.year = year;
        startDate = moment(new Date(year, 0, 1)).format("YYYY-MM-DD");
        endDate = moment(new Date(year, 12, 0)).format("YYYY-MM-DD");
      }
      this.startDate = startDate;
      this.endDate = endDate;

      const payload = {
        filter_type: this.dateFilterCategory,
        start_date: startDate,
        end_date: endDate,
      };
      const query = {
        page: 1,
      };
      this.trainerTransactionsByusersData = [];
      this.currentPage = 1;
      await this.postTrainerTransactionsByusers({ payload, query });
      this.trainerTransactionsByusersData =
        this.trainerTransactionsByusers && this.trainerTransactionsByusers.data;
      this.totalPages = this.trainerTransactionsByusers.last_page;
    },

    async handlePageChange(page) {
      this.currentPage = page;
      const query = {
        page,
      };
      const payload = {
        filter_type: this.dateFilterCategory,
        start_date: this.startDate,
        end_date: this.endDate,
      };
      this.trainerTransactionsByusersData = [];
      await this.postTrainerTransactionsByusers({ payload, query });
      this.trainerTransactionsByusersData =
        this.trainerTransactionsByusers && this.trainerTransactionsByusers.data;
    },
  },
  async created() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    const startDate = moment(new Date(currentYear, currentMonth, 1)).format(
      "YYYY-MM-DD"
    );
    const endDate = moment(new Date(currentYear, currentMonth + 1, 0)).format(
      "YYYY-MM-DD"
    );
    this.yearOfMonthAndYear = currentYear;
    this.monthOfMonthAndYear = currentMonth;
    this.startDate = startDate;
    this.endDate = endDate;

    const payload = {
      filter_type: "month",
      start_date: startDate,
      end_date: endDate,
    };
    const query = {
      page: this.currentPage,
    };
    await this.postTrainerTransactionsByusers({ payload, query });
    this.trainerTransactionsByusersData =
      this.trainerTransactionsByusers && this.trainerTransactionsByusers.data;
    this.totalPages =
      this.trainerTransactionsByusers &&
      this.trainerTransactionsByusers.last_page;
  },
};
</script>